<template>
  <div>
    <validation-observer
        v-slot="{ handleSubmit }"
        ref="refFormObserver"
    >
      <b-form
          ref="form"
          @submit.stop.prevent="handleSubmit(transferMoney($event))"
          class="form validate"
      >
        <div class="select-wrapper">
          <validation-provider
              v-slot="validationContext"
              name="student"
              :rules="{required: true}"
          >
            <b-form-group
                :label="$t('Выберите ученика')"
                label-for="student"
            >
              <v-select
                  name="student"
                  :options="students"
                  label="name"
                  v-model="form.studentId"
                  :reduce="model => model.id"
              >
              </v-select>
            </b-form-group>
          </validation-provider>
        </div>

        <div class="select-wrapper">
          <validation-provider
              v-slot="validationContext"
              name="program"
              :rules="{required: true}"
          >
            <b-form-group
                :label="$t('Выберите программу')"
                label-for="program"
            >
              <v-select
                  name="program_id"
                  :options="programs"
                  label="name"
                  v-model="form.programId"
                  :reduce="model => model.id"
              >
              </v-select>
            </b-form-group>
          </validation-provider>
        </div>

        <div class="select-wrapper">
          <validation-provider
              v-slot="validationContext"
              name="date"
              :rules="{required: true}"
          >
            <b-form-group
                :label="$t('Сумма')"
                label-for="date"
            >
              <b-form-input
                type="number"
                trim
                v-model="form.amount"
              />
            </b-form-group>
          </validation-provider>
        </div>


        <b-button type="submit" variant="primary"> {{ $t('Создать пробный урок') }}</b-button>

      </b-form>
    </validation-observer>
  </div>
</template>

<script>

import {createNamespacedHelpers} from "vuex";
import {ValidationObserver, ValidationProvider} from 'vee-validate'
const {mapState, mapActions} = createNamespacedHelpers('crm')
import {
  BAvatar,
  BBadge,
  BButton,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormSelect,
  BPagination
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import CRMApi from '@/api/crm'

export default {
  name: "index",
  data() {
    return {
      form: {
        studentId: '',
        programId: '',
        amount: '',
      },
      programs: [],
    }
  },
  computed: {
    ...mapState({
      students: state => state.students
    })
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    BAvatar,
    BBadge,
    BButton,
    BDropdown,
    BDropdownItem,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BFormSelect,
    BPagination,
    vSelect
  },
  methods: {
    ...mapActions(['getUsers']),
    transferMoney() {
      CRMApi
      .transferMoney({
        user_id: this.form.studentId,
        program_id: this.form.programId,
        amount: this.form.amount
      })
      .then(() => {
        this.$bvToast.toast('Баланс пополнен', {
          title: `Деньги успешно зачислены на баланс`,
          variant: 'success',
          solid: true,
        })
      })
      .catch(() => {
        this.$bvToast.toast('Проблемы серверов', {
          title: `Попробуйте, пожалуйста, позже`,
          variant: 'danger',
          solid: true,
        })
      })
    },
    getPrograms() {
      CRMApi.getPrograms()
      .then(res => {
        this.programs = res.data
      })
    }
  },
  created() {
    this.getPrograms()
    this.getUsers();
  }
}
</script>

<style scoped>

</style>
